var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.9011 29.21554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "github") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,10a14.9741,14.9741,0,0,0-4.7,29.2c.8.1,1-.3,1-.7V35.9c-4.2.9-5.1-2-5.1-2a4.236,4.236,0,0,0-1.7-2.2c-1.4-.9.1-.9.1-.9a3.1549,3.1549,0,0,1,2.3,1.5,3.179,3.179,0,0,0,4.4,1.2,2.74433,2.74433,0,0,1,1-2c-3.3-.4-6.8-1.7-6.8-7.4a5.96258,5.96258,0,0,1,1.5-4,5.21252,5.21252,0,0,1,.1-4s1.3-.4,4.1,1.5a15.82725,15.82725,0,0,1,3.8-.5,15.82725,15.82725,0,0,1,3.8.5c2.9-1.9,4.1-1.5,4.1-1.5a5.21252,5.21252,0,0,1,.1,4,5.512,5.512,0,0,1,1.5,4c0,5.8-3.5,7-6.8,7.4a3.85078,3.85078,0,0,1,1,2.8v4.1a.71776.71776,0,0,0,1,.7A14.93529,14.93529,0,0,0,25,10Z",
    transform: "translate(-10 -10)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIc);
export default __webpack_public_path__ + "static/media/github-ic.fb78fead2ab499db84e1bdde732a75d6.svg";
export { ForwardRef as ReactComponent };